import { render } from "./FormatNumber.vue?vue&type=template&id=bab4a9ce"
import script from "./FormatNumber.vue?vue&type=script&lang=js"
export * from "./FormatNumber.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__